import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ConnectivityService } from '../../core/connectivity/connectivity.service';

@Component({
  selector: 'app-server-unavailable-banner',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './server-unavailable-banner.component.html',
  styleUrl: './server-unavailable-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerUnavailableBannerComponent {
  protected readonly connectivity = inject(ConnectivityService);
}
